import { render, staticRenderFns } from "./GoHistoryButton.vue?vue&type=template&id=58a07575"
import script from "./GoHistoryButton.vue?vue&type=script&lang=js"
export * from "./GoHistoryButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports